import { styled } from '@mui/material';
import { StyledModalWrapper } from 'src/components/modals/styles';

export const StyledAllBeneficiariesModalWrapper = styled(StyledModalWrapper)({
  height: '75vh'
});
